import React from "react";
import Loading from "components/shared/Loading";
import ProjectsListPage from "components/ProjectsList/ProjectsListPage";
import powered_footer from "images/custom/powered.png";

class GptsProjectsListPage extends ProjectsListPage {
  render() {
    return (
      <div className="projects-list container verticalpadding">
        <div className="innerblock">
          <div className="project-cards-wrapper">
            {this.renderProfile()}
            {this.renderProjects()}
            {this.props.isLoadingMore ? <Loading /> : null}
          </div>
          <div className="gametize-footer">
            <a
              href="https://corp.gametize.com/gpts/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={powered_footer}
                alt="Powered by Gametize"
                className="footer-img"
              />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default GptsProjectsListPage;
